package com.klantenstop.web.components

import androidx.compose.runtime.Composable
import com.klantenstop.web.data.models.domain.Category
import com.klantenstop.web.data.models.domain.SearchParams
import com.klantenstop.web.navigation.Navigation
import com.materialkobweb.components.widgets.DsCard
import com.materialkobweb.components.widgets.DsCardClickableStyle
import com.materialkobweb.components.widgets.DsMaterialSymbols
import com.materialkobweb.styles.MaterialColorVars
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.px

/**
 * @param heading Renders the card's title. Its semantic tag (`Hx`) must match where the card sits
 * in the page's document outline (e.g. H2 directly under a page H1, H4 nested under a section H3);
 * its visual weight is chosen independently via each `Hx`'s `typography` parameter.
 */
@Composable
fun KsCategoryCard(
    category: Category,
    heading: @Composable (text: String, color: CSSColorValue) -> Unit
) {
    Link(
        variant = UndecoratedLinkVariant,
        path = Navigation.Screen.Search(SearchParams(category = category)).route,
        modifier = Modifier.fillMaxWidth()
    ) {
        DsCard(
            modifier = Modifier.fillMaxWidth(),
            variant = DsCardClickableStyle,
            contentPadding = 22.px
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(14.px)
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(14.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Box(
                        modifier = Modifier
                            .backgroundColor(MaterialColorVars.SurfaceContainerHighest.value())
                            .borderRadius(16.px)
                            .padding(14.px)
                    ) {
                        if (category.logo != null) {
                            StyledSvg(
                                url = category.logo?.url.orEmpty(),
                                tint = MaterialColorVars.Primary.value(),
                                modifier = Modifier.size(22.px)
                            )
                        } else {
                            DsMaterialSymbols(
                                modifier = Modifier
                                    .fontSize(22.px)
                                    .color(MaterialColorVars.Primary.value()),
                                icon = "category"
                            )
                        }
                    }

                    heading(category.name, MaterialColorVars.Primary.value())
                }


                if (category.description.isNotBlank()) {
                    SpanText(
                        modifier = Modifier
                            .fontSize(14.px)
                            .lineHeight(20.px)
                            .color(MaterialColorVars.OnSurfaceVariant.value()),
                        text = category.description
                    )
                }

            }
        }
    }
}
